// @flow
import { CURRENT_ROOM_NAME, Constant } from "../webjam/constant";
import { connect } from '../base/connection';
import { maybeShowSuboptimalExperienceNotification } from '../conference/functions.web';
import { fullScreenChanged } from '../toolbox/actions.web';
import { setRecording } from './redux/tool-webjam/actions';
import { updateSettings } from '../base/settings';
import { sendData } from '../webjam/websocket';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from './constant';
import { BASE_CONFIG } from './constant';
import { setIsRecordingLoader } from './redux/tool-webjam-v2/actions';
import publicIp from 'public-ip';
import axios from 'axios';
import { getLJsonStorage } from "./welcome-dashboard/Utils";

const es_log_url = `${Constant.App.loggerURL}/common/save-es-logs`;
import MAIN_LANG from '../../../lang/main.json';
import { ct, currentHash, getBaseConfigI } from "./constant-Utils";

declare var APP: Object;

export const _ValidateIPaddress = (ipaddress, simpleIp = false) => {

    if (simpleIp) {
        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)
    } else {
        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|-)(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|-)(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|-)(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)($|(:|_)[0-9]{2,6})$/.test(ipaddress)
    }

}

export const getStore = (state: any) => {
    return APP.store.getState()[state];
}

export const dispatch = (fn: function) => APP.store.dispatch(fn)


export const fetchRequest = () => {
    // return 
}

// put this function inside conference file inside (customise/custom/TRMC) if found in any folder
export const _startConference = (type = "") => {
    let room = CURRENT_ROOM_NAME;
    // if (room) {
    //     room = room.substring(1);
    // }
    console.log("conference start from ", type)
    let time = Math.round(new Date().getTime() / 1000);
    let willTrigger = false;
    let prevConf = sessionStorage.getItem("conference_time_" + room);
    if (prevConf) {
        if (!isNaN(prevConf)) {
            if (time - prevConf > 10) {
                willTrigger = true;
            }
        } else {
            willTrigger = true;
        }
    } else {
        willTrigger = true;
    }


    if (willTrigger) {
        sessionStorage.setItem("conference_time_" + room, time);
        if (!APP.conference.isJoined()) {
            APP.UI.start();
            APP.UI.registerListeners();
            APP.UI.bindEvents();

            [
                'webkitfullscreenchange',
                'mozfullscreenchange',
                'fullscreenchange'
            ].forEach(name =>
                document.addEventListener(name, function () {
                    APP.store.dispatch(fullScreenChanged(APP.UI.isFullScreen()));
                }));

            const { dispatch, t } = APP.store;
            // CUSTOM
            APP.store.dispatch(connect());
            // END
            maybeShowSuboptimalExperienceNotification(dispatch, t);
        } else {
            console.log("join conference move else =>", APP.conference.isJoined(), willTrigger)
        }
    }
}

// export const sendJoinRoomSocket = () => {
//     let obj = {
//         isAdmin: isAdmin,
//         name: roomData.userName,
//         email: roomData.email,
//         roomName: ipAddress,
//         socketId: localStorage.getItem('socketId'),
//         organization_id: this.props?.authOrganization?._id,
//         organization: this.props?.authOrganization?.name,
//         // jitsiId: getLocalParticipant.id
//       };
//       socketEmit("user_added", obj);
// }


export const isMobileBrowserC = () => {
    let check = false;

    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|iPad|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export const isIpad = () => {
    if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
        return true;
    }
    return false;
}

// const getPublicIp = async () => {
//     return await publicIp.v4()
// }

const getBrowserVersion = () => {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|edge|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { browser: 'IE', browserVersion: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/)
        if (tem != null) { return { browser: 'Opera', browserVersion: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
        browser: M[0],
        browserVersion: M[1]
    };
}

const getOS = () => {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    } else {
        os = "Unknown"
    }

    return os;
}

const getSource = () => {
    let details = navigator.userAgent;
    let isAndroidRegexp = /android/i;
    let isIosRegexp = /iphone|ipad/i;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    let isAndroid = isAndroidRegexp.test(details);
    let isIos = isIosRegexp.test(details);
    const browserDetails = getBrowserVersion() || {};
    const response = {
        source: '',
        sourceDetails: details,
        ...browserDetails,
        os: getOS()
    }

    if (!isMobileDevice) response.source = 'browser';

    if (isAndroid) response.source = 'android';

    if (isIos) response.source = 'IOS';

    return response;
}

export const CURRENT_TIMESTAMP = Math.round(new Date().getTime() / 1000);
export const MUSIC_MODE_STRING = "#config.disableAP=true&config.disableHPF=false&config.disableNS=false&config.disableAGC=false&config.disableAEC=false&config.audioQuality.stereo=true&config.audioQuality.opusMaxAverageBitrate=510000&config.p2p.enabled=false";

export const calculateTimeDiff = (time, allowedDiff) => {
    let prevTim = parseInt(time);

    let curreTime = Math.round(new Date().getTime() / 1000);
    let diff = curreTime - prevTim;

    return diff < allowedDiff;
}

export const PANNING_VAR = {
    NO_PANNING: "no_panning",
    VOLUME_PANNING: "volume_panning",
    DELAY_PANNING: "delay_panning"
}


export const stopRecStream = (recording = true, setValue = '', type = '') => {
    dispatch(setIsRecordingLoader(false))
    if (recording) {
        dispatch(setRecording({
            recordingStarted: null
        }))
    } else {
        dispatch(setRecording({
            streamingStarted: setValue
        }))
    }
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

var lastClick = 0;
var delay = 50;

export async function filterRemoteParticipant(isUpdateFn = '') {

    let userProfileEdit = false;
    if (getBaseConfig("profileNameEdit") == true) {
        userProfileEdit = true
    }
    const { usersData } = getStore(FEATURE_CUSTOM_REDUX)
    let data = getStore('features/base/participants').remote;
    let getLocalParticipant = getStore('features/base/participants').local;
    let users = {};
    if (data.size) {
        for (let x of data.values()) {
            if (!x.name) {
                users[x.id] = x.name;
            } else if (x.name) {
                let spl = x.name.split(" ");
                if (spl.length > 1) {
                    if (spl[0].toLowerCase() == "user") {
                        if (/^[0-9]+$/.test(spl[1])) {
                            users[x.id] = {
                                name: x.name,
                                number: parseInt(spl[1])
                            };
                        }
                    }
                }
            }
        }
    }

    let setName = 1;
    let willMove = false;

    if (getLocalParticipant.name == "" || getLocalParticipant.name == undefined || getLocalParticipant.name == "undefined") {
        willMove = true;
    }

    if (willMove) {
        if (typeof users == "object") {
            let num = 1;
            let usersNum = []
            for (let i in users) {
                num++;
                if (users[i]?.number) {
                    usersNum.push(users[i].number)
                }
            }
            let maxNum = 1;
            if (usersNum.length) {
                maxNum = Math.max(...usersNum) + 1;
            }

            if (maxNum > num) {
                num = maxNum;
            }

            setName = num;

            if (userProfileEdit == true) {
                dispatch(updateSettings({
                    displayName: "User " + setName
                }));

                if (usersData) {
                    var message = {
                        action: {
                            firstname: "User " + setName,
                            lastname: '',
                            uniqueID: usersData.uniqueId,
                        },
                        content: 'set-name',
                        isBroadcast: true,
                        sender: 'mobile',
                    };
                    sendData(message)
                }
            }
        }
        return userProfileEdit ? "User " + setName : '';
    }
}

export const AUTH_TOKEN = "auth_token";
export const SOCIAL_AUTH_TOKEN = "socialAuth";
export const SOCIAL_PATH = "socialPath";

export const getBaseConfig = (type: string): string => {
    let location = window.location.origin;
    let returnVal = undefined;
    let hasMessage = MAIN_LANG;
    try {
        let themehash = currentHash();
        let mainMessage = hasMessage["rta-trmc"]["themeMessage"][themehash][type]
        if (mainMessage) {
            return getBaseConfigI(type);
        }
    } catch (e) {

    }

    try {
        let getLocalConfig = getStore(FEATURE_CUSTOM_REDUX_V2).appBaseWebConfig;
        if (getLocalConfig) {
            if (getLocalConfig[type] != undefined) {
                returnVal = getLocalConfig[type];
            }
        }
    } catch (e) {
        console.log("requested key =>", type)
    }

    if (returnVal == undefined) {
        returnVal = BASE_CONFIG[location] != undefined ? BASE_CONFIG[location][type] : BASE_CONFIG["default"][type];
    }
    return returnVal;
}

export const getQueryString = (type) => {

    let keyPair = {}
    let data = decodeURI(window.location.search)
        .replace('?', '')
        .split('&')
        .map(param => {
            let spl = param.split("=")
            if (spl.length > 0) {
                keyPair[spl[0]] = spl[1]
            }
        })

    return keyPair[type];
}

export const preventMinus = (e) => {
    if (e.code === 'Minus') {
        e.preventDefault();
    }
};

export const decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}


export const connectAccountFlag = {
    FAILED: "failed",
    ENABLED: "enabled",
    APPROVED: "approved",
    PENDING: "pending",
}


export async function checkInternetSpeed() {
    const imageAddr = 'https://taylorrobinsonmusic.s3.amazonaws.com/internet-test-img.jpg';
    const downloadSize = 5116348; // this must match with the image above

    let startTime, endTime;
    async function measureConnectionSpeed() {
        startTime = (new Date()).getTime();
        const cacheBuster = '?nnn=' + startTime;

        const download = new Image();
        download.src = imageAddr + cacheBuster;
        // this returns when the image is finished downloading
        await download.decode();
        endTime = (new Date()).getTime();
        const duration = (endTime - startTime) / 1000;
        const bitsLoaded = downloadSize * 8;

        const speedBps = (bitsLoaded / duration).toFixed(2);
        const speedKbps = (speedBps / 1024).toFixed(2);
        const speedMbps = (speedKbps / 1024).toFixed(2);
        return {
            b: speedBps,
            k: speedKbps,
            m: speedMbps
        }
    }
    return measureConnectionSpeed()
}



export const randomString = (length = 6, stringOnly = false) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    if (stringOnly) {
        characters = characters.replace("0123456789", "")
    }

    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const SaveLog = async (log_data) => {
    let ipAddress = '';

    try {
        let preAddr = "";
        let existingIp = sessionStorage.getItem("ip_addr");
        if (existingIp) {
            try {
                existingIp = JSON.parse(existingIp);
                if (existingIp.t != undefined && existingIp.ip != undefined) {
                    if (_ValidateIPaddress(existingIp.ip)) {
                        if (calculateTimeDiff(existingIp.t, 60)) {
                            preAddr = existingIp.ip;
                        }
                    }
                }
            } catch (e) {

            }
        }
        if (preAddr) {
            ipAddress = preAddr;
        } else {
            ipAddress = await getPublicIp();
            sessionStorage.setItem("ip_addr", JSON.stringify({
                t: Math.round(new Date().getTime() / 1000),
                ip: ipAddress
            }))
        }
    } catch (error) {
        return
        ipAddress = 'Error Getting IP Address';
    }

    let mutated_log_data = {
        ...log_data,
        ip: ipAddress,
        ...getSource()
    }

    axios.post(es_log_url, mutated_log_data).then(async response => {
    }).catch(error => {
        console.log("es_log_url error =>", error);
    });
}

export const getLastKey = (obj) => {
    let objKeys = Object.keys(obj);
    let lastKey = ""
    if (objKeys.length) {
        lastKey = objKeys[objKeys.length - 1];
    }
    return lastKey
}

// export const TEMP_ROOM = "44.236.95.215";
export const TEMP_ROOM = "184.73.192.146";

export const handlePaymentWindow = (redir, target = "self") => {
    const isWindowOpened = window.open(redir, target);

    if (isWindowOpened == null || typeof (isWindowOpened) == 'undefined') {
        alert(`${ct("rta-trmc.dialogs.turnOffPopup")} ${isIpad() ? ct("rta-trmc.dialogs.goToSettings") : ''}`);
        return null;
    }
    return isWindowOpened;
}


export const prejoinDeviceCalculateFlag = {
    WAITING: "WAITING",
    RECEIVED: "RECEIVED",
    DEFAULT: "DEFAULT"
}

// Note : Not currently used
export const userHasSubscriptionOut = (userPaymentSubscription, userLoginData, getCancelAlso = false) => {
    let curTime = Math.round(new Date().getTime() / 1000);
    let isSubscriptionReq = getBaseConfig("subscriptionRequired");

    let hasSubscription = false;
    if (userPaymentSubscription.pack_id) {
        hasSubscription = true;
        if (userPaymentSubscription.is_canceled == false) {
            if (userPaymentSubscription.end_at < curTime) {
                hasSubscription = false;
            } else {
                hasSubscription = true;
            }
        } else {
            if (userPaymentSubscription.is_canceled) {
                if (getCancelAlso) {
                    if (userPaymentSubscription.end_at > curTime) {
                        hasSubscription = true;
                    }
                }
            } else {
                hasSubscription = false;
            }
        }
    }

    willJoin = false
    if (isSubscriptionReq == true) {
        if (hasSubscription) {
            willJoin = true;
            if (userLoginData?.user?.id) {
                if (!userPaymentSubscription.is_premium) {
                    willJoin = false;
                }
            }
        } else {
            if (!userLoginData?.user?.id) {
                willJoin = false;
            }
        }
    }

    return { hasSubscription, willJoin };
}

export const isSocialMobileApp = () => {
    try {
        return getLJsonStorage("auth", "is_app");
    } catch (error) {
        console.error(error, 'error on getting is_app')
        return false;
    }
}

export const InvitedUserConfirmFlag = {
    WITH_DEVICE: "WITH_DEVICE",
    WITHOUT_DEVICE: "WITHOUT_DEVICE",
    IS_CONFIRMING: "IS_CONFIRMING",
    DEFAULT: "DEFAULT",
    PENDING: "PENDING",
    WITHOUT_DEVICE_U_LOGIN: "WITHOUT_DEVICE_U_LOGIN",
}

export const isGhostUser = () => {

    let { iAmRecorder } = getStore("features/base/config")

    return window.location.href.indexOf("AUDIO_GHOST") != -1
        || window.location.href.indexOf("config.iAmRecorder") != -1
        || iAmRecorder;
}
export const DeviceInfoStatus = {
    PENDING: "PENDING",
    WAITING: "WAITING",
    RECEIVED: "RECEIVED",
    DEFAULT: "DEFAULT"
}
